import React from 'react';

import {labels} from '../../../../../../util/utils';

import Icon from '@ey/motif-react-wrapper/Icon';
import {MotifAlertIcErrorOutline24px} from '@ey-xd/motif-icon';

import {StyledTextWithOverdueIcon} from '../YesNoOverdueColumn';
import UserDate from '../../../../UserDate/UserDate';

export const config = ({
	id,
	fullId = null,
	label,
	prop,
	isOverdue = null, // function that requires item
	width = 'minmax(var(--px-123), 1fr)'
}) => ({
	id: fullId ? fullId : `${id}DateColumn`,
	label,
	propName: prop,
	width,
	sortBy: prop,
	customCell: (item) => (
		<StyledTextWithOverdueIcon body2 light>
			<UserDate date={item[prop]} />
			{isOverdue && isOverdue(item) && <Icon title={labels.overdueLabel} src={MotifAlertIcErrorOutline24px} />}
		</StyledTextWithOverdueIcon>
	)
});
